import { SelectionTag } from '@/types/modals';
import s from './TagSelection.module.scss';
import { TagContainer } from '@components/layouts/Modals/TagsSelection/TagContainer';
import { FC } from 'react';

interface Props {
  isLoading?: boolean;
  handleTagClick: (tagId: string) => void;
  displayTags: SelectionTag[];
  className?: string;
}

export const TagsSelection: FC<Props> = ({
  displayTags,
  handleTagClick,
  isLoading,
  className,
}) => {
  return (
    <div className={[s.tagsContainerWrapper, className].join(' ')}>
      <section className={s.tagsContainer}>
        {displayTags.map((tag) => (
          <TagContainer
            disabled={isLoading}
            isSelected={tag.isSelected}
            onClick={() => handleTagClick(tag.id)}
            key={tag.id}
          >
            {tag.name}
          </TagContainer>
        ))}
      </section>
    </div>
  );
};
